import { useLang } from "@/contexts/LangContext";
import { useSiteCopy } from "@/hooks/useSiteCopy";
import Reveal from "@/components/Reveal";

const WORKSHOP =
  "https://images.pexels.com/photos/10316634/pexels-photo-10316634.jpeg";

export default function About() {
  const { t, lang } = useLang();
  const copy = useSiteCopy();

  return (
    <div data-testid="page-about" className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-24 pb-32">
      <section className="pt-20 pb-16 grid grid-cols-1 md:grid-cols-12 gap-12 items-end">
        <Reveal className="md:col-span-7" y={40}>
          <p className="text-eyebrow text-brand mb-6">{t("about.eyebrow")}</p>
          <h1 className="font-display font-light text-5xl sm:text-6xl md:text-7xl text-ink leading-[0.95] tracking-tighter">
            {copy("about_title", "about.title")}
          </h1>
        </Reveal>
        <Reveal className="md:col-span-5 text-ink-muted leading-relaxed" y={40} delay={0.15}>
          {lang === "en"
            ? "Founded by a single carpenter and grown into a small, deliberately quiet workshop, C-Carpenter has spent 25 years working on the quiet, expensive end of London's private interiors and construction."
            : "Fundada por un solo carpintero y crecida hasta un taller pequeño y deliberadamente silencioso, C-Carpenter ha pasado 25 años trabajando en el extremo callado y costoso de los interiores e infraestructuras privadas de Londres."}
        </Reveal>
      </section>

      <section className="relative h-[60vh] overflow-hidden border border-edge mb-24">
        <img src={WORKSHOP} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#131211] via-transparent to-transparent" />
      </section>

      <section className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-24">
        <div className="md:col-span-6">
          <p className="text-eyebrow text-brand mb-4">{t("about.mission.title")}</p>
          <h2 className="font-display text-3xl sm:text-4xl text-ink mb-6 leading-tight">
            {t("about.mission.title")}
          </h2>
          <p className="text-ink-muted leading-relaxed">{copy("mission", "about.mission.body")}</p>
        </div>
        <div className="md:col-span-6">
          <p className="text-eyebrow text-brand mb-4">{t("about.vision.title")}</p>
          <h2 className="font-display text-3xl sm:text-4xl text-ink mb-6 leading-tight">
            {t("about.vision.title")}
          </h2>
          <p className="text-ink-muted leading-relaxed">{copy("vision", "about.vision.body")}</p>
        </div>
      </section>

      <section className="border-t border-edge pt-16">
        <p className="text-eyebrow text-brand mb-4">{t("about.values.title")}</p>
        <h2 className="font-display text-3xl sm:text-4xl text-ink mb-10 leading-tight">
          {t("about.values.title")}
        </h2>
        <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-12">
          {t("about.values.items").map((v, i) => (
            <li
              key={i}
              className="flex items-start gap-6 py-6 border-b border-edge text-ink"
              data-testid={`value-item-${i}`}
            >
              <span className="text-eyebrow text-brand pt-1">{String(i + 1).padStart(2, "0")}</span>
              <span className="text-lg font-light">{v}</span>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
